import React, { useState } from 'react';
import img from '../images/image8.webp';
import img2 from '../images/image10.webp';
import img3 from '../images/image12.webp';
import img4 from '../images/image11.webp';
import menu from '../images/menucardf_forwebsite.webp';
import './Our_massages.css';

const massages = [
  {
    title: 'Foot Massage',
    thai: 'นวดเท้า',
    price: '250 ฿ / hr',
    image: img,
    description:
      "Thai foot massage is a therapeutic technique originating from Thailand that involves applying pressure to specific points and lines on the feet to promote relaxation, improve circulation, and balance the body's energy. It combines elements of reflexology, stretching, and massage to relieve tension, stimulate the internal organs, and enhance overall well-being.",
  },
  {
    title: 'Foot Scrub Massage',
    thai: 'สครับเท้า',
    price: '350 ฿ / hr',
    image: img2,
    description:
      'The foot scrub massage is a rejuvenating treatment that involves cleansing, exfoliating, and moisturizing the feet. It aims to remove dead skin cells, promote relaxation, and improve circulation. This process is followed by a soothing massage using oils or lotions to hydrate and nourish the skin, leaving the feet revitalized and refreshed.',
  },
  {
    title: 'Thai Massage',
    thai: 'นวดไทย',
    price: '250 ฿ / hr',
    image: img3,
    description:
      'Thai massage is a traditional therapeutic practice from Thailand that combines acupressure, assisted yoga stretches, and deep tissue massage techniques. The practitioner uses rhythmic pressure and guided movements to release tension, improve flexibility, and restore the flow of energy throughout the body.',
  },
  {
    title: 'Thai Deep Tissue',
    thai: 'นวดไทยออย',
    price: '400 ฿ / hr',
    image: img4,
    description:
      'Thai deep tissue massage focuses on deeper layers of muscles and connective tissues. Firm pressure and slower strokes target areas of chronic tension and tightness, helping reduce stiffness, improve mobility, and relieve pain while keeping the restorative feel of Thai bodywork.',
  },
  {
    title: 'Oil Massage',
    thai: 'นวดออย',
    price: '300 ฿ / hr',
    image: img,
    description:
      'Oil massage is a therapeutic technique that involves the application of oils on the body to promote relaxation and healing. The smooth gliding movements reduce friction, ease muscular tension, improve blood circulation, and leave the skin nourished while creating a calm and restorative experience.',
  },
  {
    title: 'Hot Oil Massage',
    thai: 'นวดน้ำมันร้อน',
    price: '400 ฿ / hr',
    image: img2,
    description:
      'A hot oil massage uses warmed oils for a soothing and relaxing experience. The heat helps loosen tight muscles and increase circulation, while the massage strokes promote deep relaxation, relieve stress, and leave the body feeling rejuvenated.',
  },
  {
    title: 'Oil Aroma Massage',
    thai: 'นวดอโรม่า',
    price: '400 ฿ / hr',
    image: img3,
    description:
      'Oil aroma massage combines the benefits of massage with the soothing effects of aromatic essential oils. Gentle pressure and long flowing strokes help release muscle tension, reduce stress, improve circulation, and create a calming sensory experience tailored to relaxation and well-being.',
  },
  {
    title: 'Back and Shoulder',
    thai: 'นวด หลัง คอ บ่า ไหล่',
    price: '350 ฿ / hr',
    image: img4,
    description:
      'A back and shoulder massage focuses on the upper body using pressure, kneading, and targeted muscle work. It is designed to reduce stiffness, relieve pain, improve posture, and ease the common tension that builds up in the neck, shoulders, and upper back.',
  },
  {
    title: 'Thai Herb Massage',
    thai: 'นวดประคบ',
    price: '450 ฿ / hr',
    image: img,
    description:
      'Thai herb massage incorporates heated herbal compresses filled with traditional Thai herbs such as lemongrass, ginger, and turmeric. The warmth and herbal properties help relax muscles, relieve tension, promote healing, and create a soothing and invigorating treatment.',
  },
  {
    title: 'Face Massage',
    thai: 'นวดหน้า',
    price: '300 ฿ / hr',
    image: img2,
    description:
      "Face massage involves applying a soothing blend of creams to facial muscles with gentle strokes and kneading motions. It promotes relaxation, improves circulation, supports skin health, and contributes to a fresh, radiant, and well-rested appearance.",
  },
  {
    title: 'Head Massage',
    thai: 'นวดหัว',
    price: '250 ฿ / hr',
    image: img3,
    description:
      "Head massage is a therapeutic treatment where gentle pressure and circular movements are applied to the head, neck, and shoulders. It helps release tension, ease headaches, improve circulation, and create a calming sense of mental and physical relaxation.",
  },
];

const Ourmassages = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <section id="our-massages" className="mx-auto max-w-7xl px-4 py-20 md:px-6">
      <div className="text-center" data-aos="fade-up">
        <p className="text-sm font-semibold uppercase tracking-[0.28em] text-stone-500">
          Treatments
        </p>
        <h2 className="mt-4 font-cyclin text-4xl font-bold text-slate-950 md:text-5xl">
          Choose from 11 massage options
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-8 text-stone-700">
          From traditional Thai massage to oil, aroma and targeted relief,
          each treatment is designed to help you relax and feel better.
        </p>
      </div>

      <div className="mt-8 flex justify-center" data-aos="fade-up" data-aos-delay="100">
        <button
          type="button"
          onClick={() => setIsMenuOpen(true)}
          className="rounded-full border border-stone-300 bg-white/85 px-6 py-3 text-base font-semibold text-stone-900 shadow-sm transition hover:-translate-y-0.5 hover:bg-white"
        >
          View full price menu
        </button>
      </div>

      <div
        className="mt-12 grid gap-5 sm:grid-cols-2 xl:grid-cols-3"
        data-aos="fade-up"
        data-aos-delay="150"
      >
        {massages.map((massage) => (
          <article
            key={massage.title}
            className="overflow-hidden rounded-[1.9rem] border border-white/80 bg-white/82 shadow-xl shadow-stone-900/10 transition duration-300 hover:-translate-y-1.5 hover:shadow-2xl"
          >
            <div className="bg-gradient-to-br from-amber-50/90 via-white to-stone-100 px-6 pt-6">
              <img
                src={massage.image}
                alt={massage.title}
                className="h-64 w-full rounded-[1.5rem] object-cover object-center shadow-md shadow-slate-900/10"
              />
            </div>
            <div className="p-6">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-cyclin text-2xl font-bold text-slate-950">
                    {massage.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium tracking-[0.12em] text-slate-500">
                    {massage.thai}
                  </p>
                </div>
                <span className="rounded-full border border-amber-200/70 bg-amber-50/85 px-3 py-2 text-sm font-bold text-amber-900">
                  {massage.price}
                </span>
              </div>

              <p className="mt-4 text-[15px] leading-7 text-stone-700">
                {massage.description}
              </p>
            </div>
          </article>
        ))}
      </div>

      {isMenuOpen && (
        <div
          className="menu-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Full massage price menu"
          onClick={() => setIsMenuOpen(false)}
        >
          <div className="menu-modal" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              onClick={() => setIsMenuOpen(false)}
              aria-label="Close price menu"
              className="menu-close"
            >
              ×
            </button>
            <img src={menu} alt="Amonthanat Massage full menu" className="menu-image" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Ourmassages;
